import useId from '../utils/useId';
import * as React from 'react';
export const deepseekSvg = React.forwardRef(function deepseekSvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_deepseek__a_${id_0})`,
      d: 'M27.749 8.512c-.253-.124-.367.118-.505.236q-.075.066-.14.142a1.587 1.587 0 0 1-1.369.633q-1.295-.091-2.165.87-.152-1.157-1.243-1.577a2.17 2.17 0 0 1-.953-.664 2.6 2.6 0 0 1-.303-.788c-.056-.162-.107-.33-.296-.36-.183-.031-.278.142-.354.285a3.77 3.77 0 0 0-.423 1.874c-.01.684.155 1.358.48 1.962a3.95 3.95 0 0 0 1.357 1.495c.145.068.19.18.126.329-.082.286-.176.565-.259.844-.056.193-.145.223-.334.149a5.4 5.4 0 0 1-1.736-1.198 28 28 0 0 0-2.594-2.52 11 11 0 0 0-.688-.477c-1.003-.975.133-1.775.385-1.868.26-.1.095-.441-.776-.435a7.3 7.3 0 0 0-2.682.695 3 3 0 0 1-.467.137 9.2 9.2 0 0 0-2.878-.1c-1.906.193-3.402 1.08-4.487 2.67q-1.968 2.821-1.256 6.193.596 3.509 3.351 5.759c1.843 1.614 3.982 2.346 6.431 2.179 1.9 0 3.56-.634 4.986-1.893a4.5 4.5 0 0 0 1.78.403c.574.044 1.136 0 1.697-.13.739-.156.688-.857.417-.98-2.152-1.006-1.679-.603-2.108-.944 1.092-1.322 2.746-2.694 3.389-7.137q.037-.428 0-.857c0-.18.038-.242.234-.267a4 4 0 0 0 1.54-.502c1.395-.776 1.956-2.054 2.089-3.581.018-.217 0-.46-.247-.577m-12.156 13.77c-2.083-1.668-3.092-2.22-3.522-2.196-.428.025-.321.478-.233.776q.125.408.372.75.132.149.095.342a.38.38 0 0 1-.214.28c-.67.421-1.837-.143-1.888-.174a8.67 8.67 0 0 1-3.3-3.37 10.26 10.26 0 0 1-1.294-4.568c0-.39.094-.533.498-.601a4.6 4.6 0 0 1 1.515-.044c2.14.323 3.957 1.26 5.453 2.83a18.6 18.6 0 0 1 2.196 2.942 14 14 0 0 0 2.467 2.972q.427.373.89.69c-.782.092-2.114.11-3.035-.627zm1.01-6.552c-.006-.205.1-.31.309-.317a.3.3 0 0 1 .101 0 .5.5 0 0 1 .12.074c.095.106.114.217.057.342-.05.13-.145.192-.284.198-.202 0-.297-.1-.303-.298m3.105 1.625c-.184.09-.383.145-.587.162a1.2 1.2 0 0 1-.801-.255q-.436-.271-.55-.776a1.9 1.9 0 0 1 0-.595q.141-.457-.24-.745a1 1 0 0 0-.687-.199.6.6 0 0 1-.253-.08q-.255-.122-.113-.367c.056-.08.12-.148.189-.217q.58-.277 1.148 0c.385.203.727.474 1.01.8q.38.44.682.932c.183.267.335.558.442.869.07.205-.006.372-.24.471',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_deepseek__a_${id_0}`,
          x1: 16,
          x2: 16,
          y1: 7,
          y2: 25,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#5d78fe',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#3e5ffe',
        }),
      ),
    ),
  );
});
deepseekSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var deepseek = {
  category: 'brand',
  colorable: false,
  name: 'deepseek',
  svg: deepseekSvg,
};
